// @flow
import React, { PureComponent } from 'react';
import { socialNetworks } from 'utils/socialShareUtils';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  url: string,
  title: string,
  titleclass: string,
  clickTagManager: Function
};

class FooterSocial extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#',
    title: '',
    titleclass:'mb-3'
  };

  renderButtons = (): Array<React$Element<any>> => {
    const { clickTagManager } = this.props;
    const { url, title } = this.props;

    return Object.keys(socialNetworks).map(key => {
      const ShareButton = socialNetworks[key];
      let classNames = dynamicClassName('btn');
      key === 'mail' && classNames.add('btn--primary btn--social');
      key !== 'mail' && classNames.add(`btn btn--${key} btn--social`);
      
      let socialNetworkTitle = key.substr(0, 1).toUpperCase() + key.slice(1);
      if (key === 'twitter') {
        classNames.add(' btn--x is-dark');
        socialNetworkTitle = "X";
      }
      const titleProps = key !== 'facebook' ? { title: title } : {};

      const data = {
        className: classNames,
        url: (!url || url === '#' ) ? window.location.href : url,
        quote: (key === 'facebook') ? title : false,
        title: (key === 'twitter' || key === 'whatsapp') ? title : false,
        subject: (key === 'mail') ? title : false,
      };

      return (
        <ShareButton
          {... data} 
          className={classNames.build()}
          key={`${key}-share-button`}
          url={ (!url || url === '#' ) ? window.location.href : url }
          quote={title}
          subject={title}
          {...titleProps}
          beforeOnClick={clickTagManager(key)}>
          <i className={`icon icon-${key} is-inline`} />
            <span>{socialNetworkTitle}</span>
        </ShareButton>
      );
    });
  }

  render() {
    return (
      <div>
        <h3 className={this.props.titleclass}>Partager</h3>
        <div className="block-share">
          {this.renderButtons()}
        </div>
      </div>
    );
  }
}
export default FooterSocial;
